/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecurityQuestions } from '../../models/security-questions';

export interface SecurityQuestionGet2$Params {
  id: number;
}

export function securityQuestionGet2(http: HttpClient, rootUrl: string, params: SecurityQuestionGet2$Params, context?: HttpContext): Observable<StrictHttpResponse<SecurityQuestions>> {
  const rb = new RequestBuilder(rootUrl, securityQuestionGet2.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SecurityQuestions>;
    })
  );
}

securityQuestionGet2.PATH = '/api/SecurityQuestion/{id}';
